import type { ThemeOptions } from '@material-ui/core/styles/createTheme';

const testThemeVariant: ThemeOptions = {
  // overrides to be applied
  palette: {
    primary: { main: '#990000' },
  },
  typography: {
    fontFamily: 'Comic Sans',
  },
  overrides: {
    MuiDivider: {
      root: {
        color: 'red',
      },
    },
  },
  props: {
    MuiDivider: {
      absolute: true,
    },
  },
  // overrides to be ignored
  breakpoints: {
    values: {
      sm: 500,
      xs: 0,
      md: 900,
      lg: 1200,
      xl: 1920,
    },
  },
  direction: 'rtl',
  mixins: {
    toolbar: {
      minHeight: 120,
    },
  },
  shadows: [
    'none',
    '1px',
    '2px',
    '3px',
    '4px',
    '5px',
    '6px',
    '7px',
    '8px',
    '9px',
    '10px',
    '11px',
    '12px',
    '13px',
    '14px',
    '15px',
    '16px',
    '17px',
    '18px',
    '19px',
    '20px',
    '21px',
    '22px',
    '23px',
    '24px',
  ],
  spacing: 8,
  shape: {
    borderRadius: 10,
  },
  transitions: {
    duration: {
      short: 125,
    },
  },
  zIndex: {
    tooltip: 5000,
  },
  iconSizes: {
    large: '5rem',
  },
};

export default testThemeVariant;
